const INSERT_EVENT_BUTTON = "insert-event-button";
const INSERT_BOOKINGS_BUTTON = "insert-bookings-button";
const INSERT_STORES_BUTTON = "insert-stores-button";
const ROOT = "vertical-embed";
const INSERT_VERTICAL_EMBED_MODAL = "insert-vertical-embed-modal";
const INSERT_VERTICAL_EMBED_SEARCH_INPUT = "insert-vertical-embed-modal-search-input";
const INSERT_VERTICAL_EMBED_MODAL_ITEM = "insert-vertical-embed-item";
const INSERT_VERTICAL_EMBED_MODAL_ITEM_IMAGE = "insert-vertical-embed-item-image";
const INSERT_VERTICAL_EMBED_CANCEL_BUTTON = "vertical-embed-cancel-button";
const INSERT_VERTICAL_EMBED_FOOTER_ACTIONS = "vertical-embed-footer-actions";
const INSERT_VERTICAL_EMBED_ITEMS_LIST = "vertical-embed-items-list";
const VERTICAL_EMBED_TITLE = "vertical-embed-title";
const VERTICAL_EMBED_BUTTON = "vertical-embed-button";
const VERTICAL_EMBED_SUBTITLE = "vertical-embed-subtitle";
const SETTINGS_VERTICAL_EMBED_IMAGE_TOGGLE = "settings-vertical-embed-image-toggle";
const SETTINGS_VERTICAL_EMBED_TITLE_TOGGLE = "settings-vertical-embed-title-toggle";
const SETTINGS_VERTICAL_EMBED_PRICE_TOGGLE = "settings-vertical-embed-price-toggle";
const SETTINGS_VERTICAL_EMBED_BUTTON_TOGGLE = "settings-vertical-embed-button-toggle";
const SETTINGS_VERTICAL_EMBED_BUTTON_TEXT_INPUT = "settings-vertical-embed-button-text-input";
const SETTINGS_VERTICAL_EMBED_RIBBON_TOGGLE = "settings-vertical-embed-ribbon-toggle";
const SETTINGS_VERTICAL_EMBED_RIBBON_TEXT_INPUT = "settings-vertical-embed-ribbon-text-input";
const SETTINGS_VERTICAL_EMBED_DESCRIPTION_TOGGLE = "settings-vertical-embed-description-toggle";
const SETTINGS_VERTICAL_EMBED_DATETIME_TOGGLE = "settings-vertical-embed-datetime-toggle";
const SETTINGS_VERTICAL_EMBED_LOCATION_TOGGLE = "settings-vertical-embed-location-toggle";
const SETTINGS_VERTICAL_EMBED_DURATION_TOGGLE = "settings-vertical-embed-duration-toggle";
const SETTINGS_VERTICAL_EMBED_TITLE_COLOR_PICKER_TRIGGER = "settings-vertical-embed-title-color-picker-trigger";
const SETTINGS_VERTICAL_EMBED_SUBTITLE_COLOR_PICKER_TRIGGER = "settings-vertical-embed-subtitle-color-picker-trigger";
const SETTINGS_VERTICAL_EMBED_BACKGROUND_COLOR_INPUT = "settings-vertical-embed-background-color-input";
const SETTINGS_VERTICAL_EMBED_BACKGROUND_COLOR_TRIGGER = "settings-vertical-embed-background-color-trigger";
const SETTINGS_VERTICAL_EMBED_BORDER_COLOR_INPUT = "settings-vertical-embed-border-color-input";
const SETTINGS_VERTICAL_EMBED_BORDER_COLOR_TRIGGER = "settings-vertical-embed-border-color-trigger";
const SETTINGS_VERTICAL_EMBED_BORDER_WIDTH_INPUT = "settings-vertical-embed-border-width-input";
const SETTINGS_VERTICAL_EMBED_CORNER_RADIUS_INPUT = "settings-vertical-embed-corner-radius-input";
const SETTINGS_VERTICAL_EMBED_BUTTON_FILL_COLOR_INPUT = "settings-vertical-embed-button-fill-color-input";
const SETTINGS_VERTICAL_EMBED_BUTTON_FILL_COLOR_TRIGGER = "settings-vertical-embed-button-fill-color-trigger";
const SETTINGS_VERTICAL_EMBED_BUTTON_TEXT_COLOR_PICKER_TRIGGER = "settings-vertical-embed-button-text-color-picker-trigger";
const SETTINGS_VERTICAL_EMBED_BUTTON_BORDER_COLOR_INPUT = "settings-vertical-embed-button-border-color-input";
const SETTINGS_VERTICAL_EMBED_BUTTON_BORDER_COLOR_TRIGGER = "settings-vertical-embed-button-border-color-trigger";
const SETTINGS_VERTICAL_EMBED_BUTTON_BORDER_WIDTH_INPUT = "settings-vertical-embed-button-border-width-input";
const SETTINGS_VERTICAL_EMBED_BUTTON_CORNER_RADIUS_INPUT = "settings-vertical-embed-button-corner-radius-input";
const SETTINGS_VERTICAL_EMBED_BUTTON_HOVER_FILL_COLOR_INPUT = "settings-vertical-embed-button-hover-fill-color-input";
const SETTINGS_VERTICAL_EMBED_BUTTON_HOVER_FILL_COLOR_TRIGGER = "settings-vertical-embed-button-hover-fill-color-trigger";
const SETTINGS_VERTICAL_EMBED_BUTTON_HOVER_TEXT_COLOR_PICKER_TRIGGER = "settings-vertical-embed-button-hover-text-color-picker-trigger";
const SETTINGS_VERTICAL_EMBED_BUTTON_HOVER_BORDER_COLOR_INPUT = "settings-vertical-embed-button-hover-border-color-input";
const SETTINGS_VERTICAL_EMBED_BUTTON_HOVER_BORDER_COLOR_TRIGGER = "settings-vertical-embed-button-hover-border-color-trigger";
const SETTINGS_VERTICAL_EMBED_RIBBON_FILL_COLOR_INPUT = "settings-vertical-embed-ribbon-fill-color-input";
const SETTINGS_VERTICAL_EMBED_RIBBON_FILL_COLOR_TRIGGER = "settings-vertical-embed-ribbon-fill-color-trigger";
const SETTINGS_VERTICAL_EMBED_RIBBON_BORDER_COLOR_INPUT = "settings-vertical-embed-ribbon-border-color-input";
const SETTINGS_VERTICAL_EMBED_RIBBON_BORDER_COLOR_TRIGGER = "settings-vertical-embed-ribbon-border-color-trigger";
const SETTINGS_VERTICAL_EMBED_RIBBON_BORDER_WIDTH_INPUT = "settings-vertical-embed-ribbon-border-width-input";
const SETTINGS_VERTICAL_EMBED_RIBBON_CORNER_RADIUS_INPUT = "settings-vertical-embed-ribbon-corner-radius-input";
const SETTINGS_VERTICAL_EMBED_RIBBON_TEXT_COLOR_PICKER_TRIGGER = "settings-vertical-embed-ribbon-text-color-picker-trigger";
const SETTINGS_VERTICAL_EMBED_MODAL = "settings-vertical-embed-modal";
const SETTINGS_VERTICAL_EMBED_TABS = "settings-vertical-embed-tabs";
const PLUGIN_TOOLBAR_UPDATE_BUTTON = "plugin-toolbar-update-button";
export {
  INSERT_BOOKINGS_BUTTON,
  INSERT_EVENT_BUTTON,
  INSERT_STORES_BUTTON,
  INSERT_VERTICAL_EMBED_CANCEL_BUTTON,
  INSERT_VERTICAL_EMBED_FOOTER_ACTIONS,
  INSERT_VERTICAL_EMBED_ITEMS_LIST,
  INSERT_VERTICAL_EMBED_MODAL,
  INSERT_VERTICAL_EMBED_MODAL_ITEM,
  INSERT_VERTICAL_EMBED_MODAL_ITEM_IMAGE,
  INSERT_VERTICAL_EMBED_SEARCH_INPUT,
  PLUGIN_TOOLBAR_UPDATE_BUTTON,
  ROOT,
  SETTINGS_VERTICAL_EMBED_BACKGROUND_COLOR_INPUT,
  SETTINGS_VERTICAL_EMBED_BACKGROUND_COLOR_TRIGGER,
  SETTINGS_VERTICAL_EMBED_BORDER_COLOR_INPUT,
  SETTINGS_VERTICAL_EMBED_BORDER_COLOR_TRIGGER,
  SETTINGS_VERTICAL_EMBED_BORDER_WIDTH_INPUT,
  SETTINGS_VERTICAL_EMBED_BUTTON_BORDER_COLOR_INPUT,
  SETTINGS_VERTICAL_EMBED_BUTTON_BORDER_COLOR_TRIGGER,
  SETTINGS_VERTICAL_EMBED_BUTTON_BORDER_WIDTH_INPUT,
  SETTINGS_VERTICAL_EMBED_BUTTON_CORNER_RADIUS_INPUT,
  SETTINGS_VERTICAL_EMBED_BUTTON_FILL_COLOR_INPUT,
  SETTINGS_VERTICAL_EMBED_BUTTON_FILL_COLOR_TRIGGER,
  SETTINGS_VERTICAL_EMBED_BUTTON_HOVER_BORDER_COLOR_INPUT,
  SETTINGS_VERTICAL_EMBED_BUTTON_HOVER_BORDER_COLOR_TRIGGER,
  SETTINGS_VERTICAL_EMBED_BUTTON_HOVER_FILL_COLOR_INPUT,
  SETTINGS_VERTICAL_EMBED_BUTTON_HOVER_FILL_COLOR_TRIGGER,
  SETTINGS_VERTICAL_EMBED_BUTTON_HOVER_TEXT_COLOR_PICKER_TRIGGER,
  SETTINGS_VERTICAL_EMBED_BUTTON_TEXT_COLOR_PICKER_TRIGGER,
  SETTINGS_VERTICAL_EMBED_BUTTON_TEXT_INPUT,
  SETTINGS_VERTICAL_EMBED_BUTTON_TOGGLE,
  SETTINGS_VERTICAL_EMBED_CORNER_RADIUS_INPUT,
  SETTINGS_VERTICAL_EMBED_DATETIME_TOGGLE,
  SETTINGS_VERTICAL_EMBED_DESCRIPTION_TOGGLE,
  SETTINGS_VERTICAL_EMBED_DURATION_TOGGLE,
  SETTINGS_VERTICAL_EMBED_IMAGE_TOGGLE,
  SETTINGS_VERTICAL_EMBED_LOCATION_TOGGLE,
  SETTINGS_VERTICAL_EMBED_MODAL,
  SETTINGS_VERTICAL_EMBED_PRICE_TOGGLE,
  SETTINGS_VERTICAL_EMBED_RIBBON_BORDER_COLOR_INPUT,
  SETTINGS_VERTICAL_EMBED_RIBBON_BORDER_COLOR_TRIGGER,
  SETTINGS_VERTICAL_EMBED_RIBBON_BORDER_WIDTH_INPUT,
  SETTINGS_VERTICAL_EMBED_RIBBON_CORNER_RADIUS_INPUT,
  SETTINGS_VERTICAL_EMBED_RIBBON_FILL_COLOR_INPUT,
  SETTINGS_VERTICAL_EMBED_RIBBON_FILL_COLOR_TRIGGER,
  SETTINGS_VERTICAL_EMBED_RIBBON_TEXT_COLOR_PICKER_TRIGGER,
  SETTINGS_VERTICAL_EMBED_RIBBON_TEXT_INPUT,
  SETTINGS_VERTICAL_EMBED_RIBBON_TOGGLE,
  SETTINGS_VERTICAL_EMBED_SUBTITLE_COLOR_PICKER_TRIGGER,
  SETTINGS_VERTICAL_EMBED_TABS,
  SETTINGS_VERTICAL_EMBED_TITLE_COLOR_PICKER_TRIGGER,
  SETTINGS_VERTICAL_EMBED_TITLE_TOGGLE,
  VERTICAL_EMBED_BUTTON,
  VERTICAL_EMBED_SUBTITLE,
  VERTICAL_EMBED_TITLE
};
//# sourceMappingURL=data-hooks.js.map
